import DataGrid from "devextreme-react/data-grid";
import includes from "lodash/includes";
import styled from "styled-components";
export default {
    DataGrid: styled((DataGrid)).withConfig({
        shouldForwardProp: (prop) => !includes(["minRowHeight"], prop)
    }) `
    .dx-row.dx-data-row {
      height: ${({ minRowHeight }) => minRowHeight || 0}px;
    }
    .dx-datagrid-headers {
      min-height: ${({ minRowHeight, theme }) => minRowHeight
        ? `${Math.min(minRowHeight, parseInt(theme["table-header-height"])) + 1}px`
        : `${parseInt(theme["table-header-height"]) + 1}px`};
    }
    .dx-row.dx-header-row {
      height: ${({ minRowHeight, theme }) => minRowHeight
        ? `${Math.min(minRowHeight, parseInt(theme["table-header-height"]))}px`
        : theme["table-header-height"]};
    }
  `
};
